import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/header";
import { useRef, useState, useEffect } from "react";
import { Form, Button, Row, Col, Spinner, Table } from "react-bootstrap";
import API_BASE_URL from "../config";
import { authFetch } from "../utility/AuthFetch";

function CriteriaEntry() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);

  const [standardList, setStandardList] = useState([]);
  const [standard, setStandard] = useState("");
  const hasStandard = !!standard;

  const [gradeList, setGradeList] = useState([]);

  const [exam, setExam] = useState("");
  const hasExam = !!exam;

  const [criteriaList, setCriteriaList] = useState([]);
  const [criteria, setCriteria] = useState("");
  const hasCriteria = !!criteria;

  const [finYear, setFinYear] = useState("");
  const [finYearList, setFinYearList] = useState([]);
  const hasFinYear = !!finYear;

  const [div, setDiv] = useState("");
  const [divList, setDivList] = useState([]);
  const hasDiv = !!div;

  const [studentList, setStudentList] = useState([]);

  useEffect(() => {
    const fetchGrade = async () => {
      try {
        const response = await authFetch(`${API_BASE_URL}/api/grade`);
        const result = await response.json();
        setGradeList(result.grades);
      } catch (error) {
        console.error("Error fetching Grades:", error);
      }
    };

    fetchGrade();
  }, []);

  useEffect(() => {
    const fetchStandard = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/standard-options`,
        );
        const result = await response.json();
        setStandardList(result.standard);
      } catch (error) {
        console.error("Error fetching Standard:", error);
      }
    };

    fetchStandard();
  }, []);

  const fetchDiv = async (standard) => {
    setLoader(true);
    setDiv("");
    setExam("");
    if (standard === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/div-options?standard=${standard}`,
      );
      const result = await response.json();
      setDivList(result.division);
    } catch (error) {
      console.error("Error fetching division:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchCriteria = async (exam) => {
    setLoader(true);
    setCriteriaList([]);
    setCriteria("");
    setFinYear([]);
    setFinYear("");
    if (exam === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/criteria-options?type=${exam}`,
      );
      const result = await response.json();
      setCriteriaList(result.criteria);
    } catch (error) {
      console.error("Error fetching criteria:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchFinYear = async (criteria) => {
    setLoader(true);
    setFinYearList([]);
    setFinYear("");
    setStudentList([]);
    if (criteria === "") return;
    try {
      const response = await authFetch(`${API_BASE_URL}/api/finYear`);
      const result = await response.json();
      setFinYearList(result.finYear);
    } catch (error) {
      console.error("Error fetching financial year:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchStudents = async (finYear) => {
    setLoader(true);
    if (finYear === "") return;
    setStudentList([]);
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/student-criteria?standard=${standard}&div=${div}&type=${exam}&criteria=${criteria}&finYear=${finYear}`,
      );
      const result = await response.json();
      setStudentList(result.student);
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleGradeChange = (index, value) => {
    const updated = [...studentList];
    updated[index].grade = value;
    setStudentList(updated);
  };

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);

    studentList.forEach((s, index) => {
      formData.append(`grade[${s.admission}]`, s.grade);
    });

    const url = `${API_BASE_URL}/api/add-criteria-grade`;

    const method = "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Grade added successfully");
        formRef.current.reset();
        setStandard("");
        setDiv("");
        setDivList([]);
        setExam("");
        setStudentList([]);
        setCriteria("");
        setCriteriaList([]);
        setFinYear("");
        setFinYearList([]);
        setIsSubmitting(false);
        setLoader(false);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Criteria Marks Entry</h5>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formGrade">
                    <Form.Label>
                      Standard <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="standard"
                      required
                      value={standard}
                      onChange={(e) => {
                        const value = e.target.value;
                        setStandard(value);
                        fetchDiv(value);
                      }}
                    >
                      <option value="" disabled>
                        Select Standard
                      </option>
                      {standardList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.standard}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {hasStandard && (
                  <>
                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formGrade">
                        <Form.Label>
                          Division <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="div"
                          required
                          value={div}
                          onChange={(e) => {
                            const value = e.target.value;
                            setDiv(value);
                            setExam("");
                            setCriteria("");
                            setCriteriaList([]);
                          }}
                        >
                          <option value="" disabled>
                            Select Division
                          </option>
                          {divList?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.division}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {hasDiv && (
                      <>
                        <Col md={4}>
                          <Form.Group className="mb-3" controlId="formGrade">
                            <Form.Label>
                              Exam Type <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                              name="exam"
                              required
                              value={exam}
                              onChange={(e) => {
                                const value = e.target.value;
                                setExam(value);
                                fetchCriteria(value);
                              }}
                            >
                              <option value="" disabled>
                                Select Exam Type
                              </option>
                              <option value="half-yearly">Half Yearly</option>
                              <option value="annual">Annual</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        {hasExam && (
                          <>
                            <Col md={4}>
                              <Form.Group className="mb-3" controlId="formType">
                                <Form.Label>
                                  Criteria
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                  name="criteria"
                                  value={criteria}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setCriteria(value);
                                    fetchFinYear(value);
                                  }}
                                  required
                                >
                                  <option value="" disabled>
                                    Select Criteria
                                  </option>
                                  {criteriaList?.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.Name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>

                            {hasCriteria && (
                              <>
                                <Col md={4}>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formType"
                                  >
                                    <Form.Label>
                                      Financial Year
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                      name="finYear"
                                      value={finYear}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setFinYear(value);
                                        fetchStudents(value);
                                      }}
                                      required
                                    >
                                      <option value="" disabled>
                                        Select Financial Year
                                      </option>
                                      {finYearList?.map((item) => (
                                        <option key={item.id} value={item.id}>
                                          {item.fyName}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                                </Col>
                                {hasFinYear && (
                                  <Table striped bordered hover id="marksTable">
                                    <thead>
                                      <tr>
                                        <th>NAME</th>
                                        <th>ROLL No.</th>
                                        <th>ADMISSION No.</th>
                                        <th>GRADE</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {studentList?.map((item, index) => (
                                        <tr key={index}>
                                          <td>{item.name}</td>
                                          <td>{item.roll}</td>
                                          <td>{item.admission}</td>
                                          <td>
                                            <Form.Select
                                              value={item.grade || ""}
                                              onChange={(e) =>
                                                handleGradeChange(
                                                  index,
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              <option value="" disabled>
                                                Select Grade
                                              </option>

                                              {gradeList?.map((g) => (
                                                <option key={g.id} value={g.id}>
                                                  {g.grade}
                                                </option>
                                              ))}
                                            </Form.Select>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                )}
                              </>
                            )}
                          </>
                        )}{" "}
                      </>
                    )}
                  </>
                )}
              </Row>

              {hasFinYear && (
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  SUBMIT
                </Button>
              )}
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CriteriaEntry;
